import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { IOeeFormAssociation } from 'scw-digital-boards-widgets';
import { IDropdownOption, TDropdownId } from '../mat-dropdown/mat-dropdown.component';
import { IDropdownSettings } from '../mat-dropdown/scw-mat-dropdown.interface';

export enum EOeeFormAssociationEnum {
  shift = 'shift',
  line = 'line',
  workOrder = 'workOrder',
  currentWorkOrder = 'currentWorkOrder',
  currentShift = 'currentShift',
}

export enum EActionTrackerFormAssociationEnum {}

export type TFormAssociationEnum = EOeeFormAssociationEnum | EActionTrackerFormAssociationEnum;

export interface IWorkOrder {
  id: number;
  woNumber: string;
  siteId: number;
  lastLine: number | null;
  actualLine: number | null;
}

export interface ILine {
  id: number;
  title: string;
}

export interface IShift {
  id: number;
  name: string;
}

export type TConfig = {
  loadFn: ($event?: string) => void;
  observable$: Observable<IDropdownOption<TDropdownId>[]>;
  configurationInput: () => IDropdownSettings;
  getSelectedIds?: (oeeFormAssociation: IOeeFormAssociation) => TDropdownId[];
};

export type TDropdownConfig<T extends TDropdownId> = {
  configurationInput: IDropdownSettings;
  options: IDropdownOption<T>[];
  formControl: FormControl<IDropdownOption<T>[] | null>;
  loadFn?: ($event?: string) => void;
  currentSearchText?: string;
  hasLoadedInitialSelection?: boolean;
};

export type TChildDropdowns<T extends TDropdownId> = Record<TFormAssociationEnum, TDropdownConfig<T> | undefined>;
